import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { EmployeeItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const EditCDNFile = () => {
	const { id } = useParams<{ id: string }>();
	const { updateCDNFile, loadingEditCDNFileData, getCDNFileDetails } = useCDNFileContext();

	useEffect(() => {
		if (id) {
			getCDNFileDetails(id);
		}
	}, [id]);

	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>CDN Dosyasını Güncelle</h3>
				<Divider />
				<Collapse
					items={EmployeeItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={updateCDNFile} type="default" loading={loadingEditCDNFileData}>
						Güncelle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default EditCDNFile;
